// KBT-1310: a special id that we use for host element, Popover and Fullscreen
export const FLOATING_MANAGER_ID = 'floating-components-host';

export const getFloatingHostElement = () =>
  document.getElementById(FLOATING_MANAGER_ID || document.body);
